export const environment = {
    production: false,
    showDebug: false,
    apiUrl: 'https://devmyke-playground.business.unc.edu/api',

    ssoUrl: "https://login.microsoftonline.com/ae2008a1-f68d-414a-a9ab-336bc8a857d2/oauth2/v2.0/authorize?client_id=a8d55d18-1265-43e6-acf9-89b3c9c050f7&response_type=code&redirect_uri=https://devmyke-playground.business.unc.edu/client/login/ocid&response_mode=query&scope=openid",

    // Prior to MS Auth, we used this Ping SSO 
    //ssoUrl: 'https://fedtest.business.unc.edu/as/authorization.oauth2?client_id=dev_myke_student&response_type=code&redirect_uri=https://devmyke.business.unc.edu/client/login/ocid',

    alertPollingFrequency: 20000
};
// alertPollingFrequency is in Milliseconds
